import * as React from "react";
import PreferenceService from "../js/preferenceService";
import {logMessageToServer} from '../js/loggerService';
import App from "./app.jsx";

const fullyQualifiedNameForProjects = "IntentGate.selected.projects";
const fullyQualifiedNameForSources = "IntentGate.selected.sources";

function Main(props) {
    const preferenceService = new PreferenceService();
    const [selectedProjectTypes, setSelectedSProjectTypes] = React.useState(null);
    const [selectedSourceTypes, setSelectedSourceTypes] = React.useState(null);

    React.useEffect(() => {
        preferenceService.fetchMultipleData([fullyQualifiedNameForProjects, fullyQualifiedNameForSources])
            .then(response => {
                const projectTypes = response[fullyQualifiedNameForProjects] ? JSON.parse(response[fullyQualifiedNameForProjects]) : [];
                const sourceTypes = response[fullyQualifiedNameForSources] ? JSON.parse(response[fullyQualifiedNameForSources]) : [];

                setSelectedSProjectTypes(projectTypes);
                setSelectedSourceTypes(sourceTypes);

                // initTrialLuncher();
                logMessageToServer("INFO","TRIAL","Successfully launched init trial launcher");
            }).catch(response => {
                setSelectedSProjectTypes([]);
                setSelectedSourceTypes([]);
                // initTrialLuncher();
                logMessageToServer("ERROR","TRIAL","Unable to fetch preferences");
            });

    }, []);

    if (selectedProjectTypes && selectedSourceTypes) {
        return <App selectedProjectTypes={selectedProjectTypes} selectedSourceTypes={selectedSourceTypes} />;
    }
    return null;
}

export default Main;